import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Loader2 } from "lucide-react";

export default function IntrospectionForm({ onSubmit }) {
    const { t } = useTranslation();
    const [form, setForm] = useState({
        favourite_passage: "",
        overall_feeling: "",
        biggest_question: "",
        would_recommend: "",
        rating: 4,
    });
    const [busy, setBusy] = useState(false);

    const handle = async (e) => {
        e.preventDefault();
        setBusy(true);
        const payload = {
            ...form,
            favourite_passage: form.favourite_passage.trim() || null,
            overall_feeling: form.overall_feeling.trim() || null,
            biggest_question: form.biggest_question.trim() || null,
            would_recommend: form.would_recommend.trim() || null,
        };
        await onSubmit(payload);
        setBusy(false);
    };

    return (
        <form onSubmit={handle} className="space-y-6" data-testid="introspection-form">
            <p className="text-xs uppercase tracking-[0.3em] text-[var(--accent)]">{t("clubs.intro_title")}</p>
            <p className="text-sm text-[var(--ink-muted)]">{t("clubs.intro_lead")}</p>

            {[
                { k: "favourite_passage", multi: true },
                { k: "overall_feeling", multi: true },
                { k: "biggest_question", multi: true },
                { k: "would_recommend", multi: false },
            ].map(({ k, multi }) => (
                <label key={k} className="block">
                    <span className="block text-xs uppercase tracking-widest text-[var(--ink-muted)] mb-2">
                        {t(`clubs.intro_q_${k}`)}
                    </span>
                    {multi ? (
                        <textarea
                            data-testid={`intro-${k}`}
                            rows={3}
                            value={form[k]}
                            onChange={(e) => setForm({ ...form, [k]: e.target.value })}
                            className="w-full bg-transparent border-b border-[var(--ink)] py-2 text-base text-[var(--ink)] focus:outline-none focus:border-[var(--accent)] transition-colors resize-none"
                        />
                    ) : (
                        <input
                            data-testid={`intro-${k}`}
                            value={form[k]}
                            onChange={(e) => setForm({ ...form, [k]: e.target.value })}
                            className="w-full bg-transparent border-b border-[var(--ink)] py-2 text-base text-[var(--ink)] focus:outline-none focus:border-[var(--accent)] transition-colors"
                        />
                    )}
                </label>
            ))}

            <div>
                <span className="block text-xs uppercase tracking-widest text-[var(--ink-muted)] mb-2">
                    {t("clubs.intro_rating")}
                </span>
                <div className="flex gap-2">
                    {[1, 2, 3, 4, 5].map((n) => (
                        <button
                            key={n}
                            type="button"
                            data-testid={`intro-rating-${n}`}
                            onClick={() => setForm({ ...form, rating: n })}
                            className={`w-10 h-10 border transition-colors ${
                                form.rating >= n
                                    ? "bg-[var(--accent)] border-[var(--accent)] text-[var(--bg)]"
                                    : "border-[var(--border-strong)] text-[var(--ink-muted)] hover:border-[var(--ink)]"
                            }`}
                        >
                            {n}
                        </button>
                    ))}
                </div>
            </div>

            <button
                type="submit"
                data-testid="intro-submit"
                disabled={busy}
                className="inline-flex items-center gap-2 bg-[var(--ink)] text-[var(--bg)] rounded-full hover:bg-[var(--accent)] disabled:opacity-50 transition-colors px-6 py-2.5 text-sm uppercase tracking-widest"
            >
                {busy && <Loader2 size={14} className="animate-spin" />}
                {t("clubs.intro_submit")}
            </button>
        </form>
    );
}
